import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import SimpleAppMethod from "./simple-app-method.vue";
import FullApplicationMethod from "./full-application-method.vue";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { mapActions, mapGetters } from "vuex";
import { LOAD_FLOWS } from "../store/applications-list-actions";
import Amplitude from "../../../../../../../../shared/utils/amplitude";
import { CLIENT_PROFILE_CO_APPLICANTS } from "@Broker/@Modules/clients/board/store/board-getters";
import { defer } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddClientModal",
  components: {
    Select2,
    GenericModal,
    SimpleAppMethod,
    FullApplicationMethod
  },
  props: {
    clientDetails: {
      type: Object,
      default: () => ({
        givenName: "",
        familyName: "",
        phoneNumber: "",
        email: "",
        flow: ""
      })
    },
    agentUsername: {
      type: String,
      default: ""
    },
    method: {
      type: String,
      default: ""
    },
    requestPersonalDetails: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      type: String,
      default: ""
    },
    additional: {
      type: Boolean,
      default: false
    },
    clientProfileId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      selectedMethod: this.method
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [CLIENT_PROFILE_CO_APPLICANTS])), {}, {
    showIncludeCoApplicants() {
      var _context;
      if (!this.clientProfileId) return true;
      return _filterInstanceProperty(_context = this.CLIENT_PROFILE_CO_APPLICANTS(this.clientProfileId)).call(_context, ({
        id
      }) => id).length > 0;
    }
  }),
  watch: {
    method(val) {
      this.selectedMethod = val;
    },
    selectedMethod(val) {
      Amplitude.logEvent("Add Client Modal - method selected", {
        data: {
          method: val
        }
      });
    }
  },
  mounted() {
    defer(() => this.LOAD_FLOWS());
  },
  beforeDestroy() {
    $("#add-client-modal").remove();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [LOAD_FLOWS])), {}, {
    resetSelectedMethod() {
      this.selectedMethod = "";
    },
    handleShow() {
      Amplitude.logEvent("Add Client Modal - shown");
    },
    handleHidden() {
      this.$emit("hidden");
      this.resetSelectedMethod();
      Amplitude.logEvent("Add Client Modal - hidden");
    },
    show() {
      this.$refs.addClient.show();
    },
    hide() {
      this.$refs.addClient.hide();
    }
  })
});